export default "__VITE_ASSET__69a4cf19__"